export enum SubscriptionFileSortField {
  SUBSCRIPTION_DESCRIPTION = 'SUBSCRIPTION_DESCRIPTION',
  SUBSCRIPTION_START_DATE = 'SUBSCRIPTION_START_DATE',
  FILE_NAME = 'FILE_NAME',
  FILE_SIZE = 'FILE_SIZE',
  FILE_CREATION_TIME = 'FILE_CREATION_TIME',
  FILE_UPDATE_TIME = 'FILE_UPDATE_TIME'
}
